import { get, isEmpty } from 'lodash';
import { IAuditLog, IEntityFilterItem, IOperationHistory } from '../types';
import { I18n } from '@app/i18n/strings-keys';
import { XVII18nService } from '@app/i18n/services';

export const returnOperatorItem = (
  operation: IOperationHistory,
  doc: IAuditLog,
  i18nService: XVII18nService,
): IEntityFilterItem => ({
  text: isEmpty(get(operation, 'operator_name'))
    ? i18nService.translate(I18n.Common.Unknown)
    : operation.operator_name,
  value: isEmpty(get(operation, 'operator_name'))
    ? doc.info.person_id
    : operation.operator_id,
});
